export default __webpack_public_path__ + "static/media/twitter.ef7ea31e.svg";